"use strict";
exports.__esModule = true;
exports.fromAlgorandResourcesRaw = exports.toAlgorandResourcesRaw = void 0;
var bignumber_js_1 = require("bignumber.js");
function toAlgorandResourcesRaw(r) {
    var rewards = r.rewards, nbAssets = r.nbAssets;
    return {
        rewards: rewards.toString(),
        nbAssets: nbAssets
    };
}
exports.toAlgorandResourcesRaw = toAlgorandResourcesRaw;
function fromAlgorandResourcesRaw(r) {
    var rewards = r.rewards, nbAssets = r.nbAssets;
    return {
        rewards: new bignumber_js_1.BigNumber(rewards),
        nbAssets: nbAssets
    };
}
exports.fromAlgorandResourcesRaw = fromAlgorandResourcesRaw;
//# sourceMappingURL=serialization.js.map